// globalNavi.js
import { gsap } from 'gsap/all'
import GnavDrilldownMenu from './gnavDrilldownMenu'
import { primaryEase } from '../utils/customEase'

// GlobalNavi
export default class GlobalNavi {
  constructor() {
    this.html = document.querySelector('html')
    this.body = document.querySelector('body')
    this.gnav = document.querySelector('.js-gnav')
    this.gnavWrapper = document.querySelector('.js-gnav-wrapper')
    this.gnavItems = document.querySelectorAll('.js-gnav-item')
    this.gnavLinks = document.querySelectorAll('.js-gnav-link')
    this.gnavLabels = document.querySelectorAll('.js-gnav-label')
    this.gnavToggle = document.querySelector('.js-gnav-toggle')
    this.gnavToggleBars = document.querySelectorAll('.l-gnav-toggle__bar')
    this.gnavToggleBarsArr = Array.from(this.gnavToggleBars)
    this.gnaviCloses = document.querySelectorAll('.js-gnav-close')
    this.isOpen = false
    this.isAnimating = false
    this.stdDuration = 0.8
    this.init()
  }

  init() {
    // GnavDrilldownMenu
    this.GnavDrilldownMenu = new GnavDrilldownMenu()

    // 現在のページに応じてクラスを付与
    this.addCurrentClass()

    this.bindEvent()
  }

  bindEvent() {
    this.gnavToggle.addEventListener('mouseenter', this.handleToggleMouseEnter.bind(this))
    this.gnavToggle.addEventListener('click', this.handleToggleClick.bind(this))

    if (this.gnaviCloses) {
      this.gnaviCloses.forEach((close) => close.addEventListener('click', this.naviClose.bind(this)))
    }
  }

  handleToggleMouseEnter(e) {
    const x = e.clientX - e.target.getBoundingClientRect().left - e.currentTarget.clientWidth / 2
    const pramBefore = x < 0 ? '100%' : '-100%'
    const pramAfter = x < 0 ? '-100%' : '100%'
    this.toggleAnime(pramBefore, pramAfter)
  }

  handleToggleClick() {
    if (!this.isAnimating) {
      this.isOpen ? this.naviClose() : this.naviOpen()
    }
  }

  addCurrentClass() {
    const currentUrl = window.location.pathname
    this.gnavLinks.forEach((link) => {
      const linkHref = link.getAttribute('href')
      if (currentUrl === linkHref || (currentUrl.startsWith(linkHref) && linkHref !== '/')) {
        link.classList.add('is-current')
      } else {
        link.classList.remove('is-current')
      }
    })
  }

  naviOpen() {
    this.killGnavTweens()
    this.toggleAnime('100%', '-100%')
    this.setScrollState(true)
    this.isAnimating = true
    this.isOpen = true

    gsap
      .timeline()
      .set(this.gnav, { clipPath: 'polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)', display: 'block' })
      .set(this.gnavWrapper, { y: '8rem' })
      .to(this.gnav, {
        clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
        duration: this.stdDuration,
        ease: primaryEase, // Use the custom ease here
        onComplete: () => (this.isAnimating = false),
      })
      .to(this.gnavWrapper, { duration: this.stdDuration, y: '0%', ease: 'power2.out' }, '<')
      .set(this.gnavWrapper, { clearProps: 'transform' })
  }

  naviClose() {
    this.killGnavTweens()
    this.toggleAnime('100%', '-100%')
    this.setScrollState(false)
    this.isAnimating = true

    gsap
      .timeline()
      // .to(this.gnavWrapper, { y: '-8rem', duration: this.stdDuration, ease: 'power2.inOut' })
      .to(
        this.gnav,
        {
          clipPath: 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)',
          duration: this.stdDuration,
          ease: primaryEase, // Use the custom ease here
          display: 'none',
          onComplete: () => this.handleCloseComplete(),
        },
        '<',
      )

    this.animateToggleBars()
  }

  handleCloseComplete() {
    this.html.classList.remove('is-gnav-open')
    this.GnavDrilldownMenu.reset()
    this.isAnimating = false
    this.isOpen = false
  }

  killGnavTweens() {
    gsap.killTweensOf(this.gnav)
  }

  setScrollState(disable) {
    this.html.classList.toggle('is-unscroll', disable)
    this.html.classList.toggle('is-gnav-open', disable)
  }

  toggleAnime(pramBefore, pramAfter) {
    if (!this.gnavToggle.classList.contains('is-mouseover')) {
      this.gnavToggle.classList.add('is-mouseover')
      this.gnavToggleBarsArr.forEach((el, index) => {
        const front = el.querySelector('.l-gnav-toggle__bar-front')
        gsap.set(front, { x: '0%' })
        gsap.to(front, {
          duration: 0.5,
          x: pramBefore,
          ease: 'power3.in',
          delay: 0.1 * index,
          onComplete: () => {
            gsap.set(front, { x: pramAfter })
            gsap.to(front, {
              duration: 0.5,
              x: '0%',
              ease: 'power3.out',
              onComplete: () => {
                this.gnavToggle.classList.remove('is-mouseover')
              },
            })
          },
        })
      })
    }
  }

  animateToggleBars() {
    this.gnavToggleBarsArr.forEach((el, index) => {
      const front = el.querySelector('.l-gnav-toggle__bar-front')
      gsap.set(front, { x: '0%' })
      gsap.to(front, {
        duration: 0.3,
        x: '100%',
        ease: 'power3.inOut',
        delay: 0.1 * index,
        onComplete: () => {
          gsap.set(front, { x: '-100%' })
          gsap.to(front, {
            duration: 0.3,
            x: '0%',
            ease: 'power3.inOut',
            onComplete: () => {
              this.gnavToggle.classList.remove('is-mouseover')
            },
          })
        },
      })
    })
  }

  removeCurrentClass() {
    this.gnavLinks.forEach((el) => {
      el.classList.remove('is-current')
    })
  }
}
